module.exports = __webpack_public_path__ + "img/treefriendsthumb.1ad87673.gif";